export default __webpack_public_path__ + "static/media/IMG_0306.507ba6c9.jpeg";